import gql from 'graphql-tag';

export const createCheckupReservationForOrganization = gql`
  mutation createCheckupReservationForOrganization($input: ReserveCheckupAppointmentInput!) {
    reserveCheckupAppointmentOrganization(input: $input) {
      id
    }
  }
`;
